
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/detail",
      function () {
        return require("private-next-pages/product/detail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/detail"])
      });
    }
  